import type {
  YachtCategory,
  YachtDieValue,
  YachtUpperCategory,
} from "../types";
import {
  YACHT_CATEGORIES,
  YACHT_LOWER_CATEGORIES,
  YACHT_UPPER_CATEGORIES,
} from "../types";

export { YACHT_CATEGORIES, YACHT_LOWER_CATEGORIES, YACHT_UPPER_CATEGORIES };

export function isYachtCategory(value: unknown): value is YachtCategory {
  return (
    typeof value === "string" &&
    YACHT_CATEGORIES.some((category) => category === value)
  );
}

export function isUpperCategory(
  category: YachtCategory,
): category is YachtUpperCategory {
  return YACHT_UPPER_CATEGORIES.some((candidate) => candidate === category);
}

export function getUpperFaceValue(category: YachtUpperCategory): YachtDieValue {
  switch (category) {
    case "ONES":
      return 1;
    case "TWOS":
      return 2;
    case "THREES":
      return 3;
    case "FOURS":
      return 4;
    case "FIVES":
      return 5;
    case "SIXES":
      return 6;
  }
}
